(() => {
  const root = document.querySelector('[data-jc-search]');
  if (!root || !root.querySelector('[data-search-tab]')) return;
  const currentUrl = new URL(location.href);
  if (currentUrl.searchParams.get('type') !== 'product') {
    currentUrl.searchParams.set('type', 'product');
    location.replace(currentUrl);
    return;
  }
  const tabs = Array.from(root.querySelectorAll('[data-search-tab]'));
  const articlePanel = root.querySelector('#jc-search-inspiration');
  const ja = document.documentElement.lang === 'ja';
  const setTab = (tab, focus = false) => {
    tabs.forEach(button => {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
      const panel = root.querySelector('#' + button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    if (focus) tab.focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => setTab(tab));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); setTab(tabs[next], true); }
    });
  });
  let controller;
  const loadArticles = async (url) => {
    controller?.abort(); controller = new AbortController();
    const requestController = controller;
    articlePanel.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, {credentials:'same-origin', signal:requestController.signal});
      if (!response.ok) throw new Error('Search response failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = html.querySelector('[data-search-inspiration-results]');
      if (!result) throw new Error('Search result missing');
      if (requestController !== controller) return;
      articlePanel.replaceChildren(result);
      root.querySelector('[data-search-article-count]').textContent = result.dataset.resultCount;
    } catch (error) {
      if (error.name === 'AbortError') return;
      const message = document.createElement('p'); message.className = 'jc-search-empty';
      message.textContent = ja ? '読み込みできませんでした。もう一度お試しください。' : 'The results could not be loaded. Please try again.';
      const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'button button--secondary';
      retry.textContent = ja ? '再試行' : 'Try again'; retry.addEventListener('click', () => loadArticles(url));
      articlePanel.replaceChildren(message, retry);
    } finally { if (requestController === controller) articlePanel.removeAttribute('aria-busy'); }
  };
  const articleUrl = new URL(articlePanel.dataset.searchArticlesUrl, location.origin);
  articleUrl.searchParams.set('q', articlePanel.dataset.searchQuery || '');
  articleUrl.searchParams.set('type', 'article,page');
  articleUrl.searchParams.set('section_id', 'jc-search-inspiration');
  loadArticles(articleUrl);
  // A direct product-page URL must not paginate the independent collection list.
  if (Number(currentUrl.searchParams.get('page')) > 1) {
    const categoryPanel = root.querySelector('#jc-search-categories');
    const categoryCount = root.querySelector('[data-search-category-count]');
    const categoryUrl = new URL(articleUrl);
    categoryUrl.searchParams.set('type', 'product');
    categoryUrl.searchParams.set('section_id', 'jc-search-categories');
    categoryCount.textContent = '…';
    const loadCategories = async () => {
      categoryPanel.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(categoryUrl, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Categories unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = html.querySelector('[data-search-category-results]');
        if (!result) throw new Error('Categories missing');
        categoryPanel.replaceChildren(result);
        categoryCount.textContent = result.dataset.resultCount;
      } catch {
        const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'button button--secondary';
        retry.textContent = ja ? 'カテゴリーを再読み込み' : 'Reload categories';
        retry.addEventListener('click', loadCategories); categoryPanel.replaceChildren(retry);
      } finally { categoryPanel.removeAttribute('aria-busy'); }
    };
    loadCategories();
  }
  articlePanel.addEventListener('click', event => {
    const link = event.target.closest('[data-search-article-page]');
    if (!link) return;
    event.preventDefault();
    const next = new URL(link.href);
    next.searchParams.set('section_id', 'jc-search-inspiration');
    loadArticles(next);
    articlePanel.scrollIntoView({block:'start', behavior:'smooth'});
  });
})();
